import React from 'react';
import { Button, Tooltip, Whisper } from 'rsuite';
import { TransactionData } from '../utils/transactionUtils';
import { getPaymentMode } from '../utils/transactionUtils';
import { InfoCircleIcon } from './icons';
import { formatNumberWithDecimals } from '../../../utils/utils';

interface TransactionSummaryProps {
  transaction: TransactionData | null;
}

export const TransactionSummary: React.FC<TransactionSummaryProps> = ({ transaction }) => {
  if (!transaction) return null;

  return (
    <div className='flex flex-col gap-4 w-full relative'>
      <div className='flex justify-between w-full'>
        <span className='text-light/70 text-base'>Payment mode</span>
        <span className='text-main font-medium'>
          {getPaymentMode(
            transaction.paymentMethodName,
            transaction.cardCompany,
            transaction.cardType
          )}
        </span>
      </div>

      <div className='flex justify-between w-full'>
        <span className='text-light/70 text-base'>Rent amount</span>
        <span className='text-main font-medium'>
          ${formatNumberWithDecimals(transaction.rentAmount)}
        </span>
      </div>

      <div className='flex justify-between w-full'>
        <div className='flex items-center gap-1'>
          <span className='text-light/70 text-base'>Processing fee</span>
          <Whisper
            trigger='hover'
            placement={'top'}
            controlId={`control-id-top`}
            speaker={
              <Tooltip>
                {Number(transaction.fixedFee) !== 0 && (
                  <div style={{ marginTop: '12px' }}>
                    <div>
                      <strong>Fixed processing fee:</strong>
                    </div>
                    <div>${Number(transaction.fixedFee).toLocaleString()}</div>
                  </div>
                )}

                {Number(transaction.percentageProcessingFee) !== 0 && (
                  <div style={{ marginTop: '8px' }}>
                    <div>
                      <strong>Processing fee ({transaction.percentageRate}%):</strong>
                    </div>
                    <div>${transaction.percentageProcessingFee}</div>
                  </div>
                )}
              </Tooltip>
            }
          >
            <Button appearance='subtle'>
              <InfoCircleIcon />
            </Button>
          </Whisper>
        </div>

        <span className='text-main font-medium'>
          ${transaction.processingFee.toLocaleString('en-US')}
        </span>
      </div>

      {transaction.discountAmount > 0 && (
        <div className='flex justify-between w-full'>
          <span className='text-light/70 text-base'>Rent credit</span>
          <span className='text-success font-semibold text-base'>
            ${transaction.discountAmount?.toLocaleString('en-US')}
          </span>
        </div>
      )}

      {transaction.promoCodeDiscountAmount > 0 && (
        <div className='flex justify-between w-full'>
          <span className='text-light/70 text-base'>Promo code discount</span>
          <span className='text-success font-semibold text-base'>
            ${transaction.promoCodeDiscountAmount?.toLocaleString('en-US')}
          </span>
        </div>
      )}

      <div className='flex justify-between w-full'>
        <span className='text-light/70 text-base'>Total amount paid</span>
        <span className='text-primary font-bold text-base'>
          ${transaction.totalAmount.toLocaleString()}
        </span>
      </div>
    </div>
  );
};

